<template>
  <div class="space-y-4">
    <h2>{{ t('extraKmCategoryFactors') }}</h2>
    <p class="whitespace-break-spaces">{{ t('description') }}</p>
    <MultipleValuesListField
      name="extraKmCategoryFactors"
      :button-text="t('addCategoryFactor')"
      :field-settings="fieldSettings"
      show-delete-alert
    />
  </div>
</template>

<script lang="ts" setup>
import MultipleValuesListField, {
  type FieldSettings,
} from '@/components/MultipleValuesListField.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { VehicleCategory } from '@/entities/vehicle-category.enum.ts';

const { t } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: 'category',
    label: t('category'),
    type: 'select',
    options: Object.values(VehicleCategory).map((category) => ({
      label: t(`categories.${category}`),
      value: category,
    })),
  },
  {
    name: 'factor',
    label: t('factor'),
    type: 'number',
    maxFractionDigits: 10,
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "extraKmCategoryFactors": "Extra km price category factors",
    "addCategoryFactor": "+ Add category factor",
    "category": "Category",
    "factor": "Factor",
    "description": "A factor that influences the automatic calculation of the price per extra km.\nIt is added to the net price per extra km, which is then multiplied by a profit margin factor & tax."
  },
  "de": {
    "extraKmCategoryFactors": "Extra-KM-Preis Kategoriefaktoren",
    "addCategoryFactor": "+ Kategoriefaktor hinzufügen",
    "category": "Kategorie",
    "factor": "Faktor",
    "description": "Ein Faktor, der die automatische Berechnung des Preises pro Extra-KM beeinflusst.\nWird auf den Netto-Preis pro Extra-KM addiert, woraufhin die Summe mit einem Gewinnspannenfaktor & MwSt. multipliziert wird."
  },
  "es": {
    "extraKmCategoryFactors": "Factores de categoría del precio por km extra",
    "addCategoryFactor": "+ Añadir factor de categoría",
    "category": "Categoría",
    "factor": "Factor",
    "description": "Un factor que influye en el cálculo automático del precio por km extra.\nSe suma al precio neto por km extra, que luego se multiplica por un margen e impuestos."
  }
}
</i18n>
